import Param from '../../param';

const param = new Param();

export default class YoutubeManager {
    constructor(){

        this.player = {};
        this.yt = {};
        this.width = {};
        this.height = {};

        if(document.getElementById('player')　!= null){
            this.width['player'] = document.getElementById('player').clientWidth;
            this.height['player'] = document.getElementById('player').clientHeight;
        }

        this.status = {
            load : false,
            play : false,
            pause : true
        }

    }
    init(domID = param.youtube.domID, id = param.youtube.id){
        let _change = (event) => {
            this.yt[domID] = event.data;
        };

        this.width[domID] = document.getElementById(domID).clientWidth;
        this.height[domID] = document.getElementById(domID).clientHeight;


        this.player[domID] = new YT.Player(domID, {
            width: this.width[domID],
            height: this.height[domID],
            videoId: id,
            events: {
              'onStateChange': _change
            },
            playerVars: {
                'autoplay' : 0,
                'html5': 1,
                'modestbranding': 1,
                //'controls':0,
                'rel':0,
                'enablejsapi':1,
                'showinfo':0
            },
        });
    }

    // change(event){
    //     //let _this = this;
    //     //console.log(this.player);
    //     //this.yt = event.data;
    //     return event.data;
    // }


    play(domID){
        if(param.displayType === 'sp'){
            this.player[domID].mute();
        }
        this.player[domID].playVideo();
    }

    resize(){

        // if($("#"+param.youtube.domID)[0]){
        //     this.width = $("#"+param.youtube.domID).innerWidth();
        //     this.height = $("#"+param.youtube.domID).innerHeight();
        // }



    }


}
